
let pickedDate = true
let inputBackupInventories = []
let inputMainInventories = []

let selectBackupProduct = null
let selectMainProduct = null

window.addEventListener('DOMContentLoaded', () => {
  selectBackupProduct = document.querySelector('#backup-product')
  selectMainProduct = document.querySelector('#product-select')
  inputBackupInventories = Array.from(selectBackupProduct.querySelectorAll('option'))
  inputMainInventories = Array.from(selectMainProduct.querySelectorAll('option'))

  loadCalendar()
})
/**
 * this loads the calendar library air calendar using JQuery 
 * @returns void
*/
let canBlockFirstSatuday = true
let canBlockFirstSunday = true

function loadCalendar() {

  if( bookingDatepicker ) {
    window.$(bookingDatepicker).datepicker({
      language: 'es',
      minDate: new Date( Date.now() + (86400000 * 3) ),
      range: true,
      onRenderCell: function(date, cellType) {

        const day = date.getDay()

        // we block first saturday
        if( canBlockFirstSatuday && day === 6 ) {
          canBlockFirstSatuday = false
          return {
            disabled: true,
            attrs: {
              title: 'Dia no disponible'
            }
          }
        }

        // also with first sunday
        if( canBlockFirstSunday && day === 0 ) {
          canBlockFirstSunday = false
          return {
            disabled: true,
            attrs: {
              title: 'Dia no disponible'
            }
          }
        }

        const selectedMainValue = selectMainProduct.value
        const selectedBackupValue = selectBackupProduct.value

        const mainInventory = Number( inputMainInventories.find((input) => input.value === selectedMainValue)?.getAttribute('data-inventory') )
        
        // we validate both, main and backup select
        if( selectedBackupValue !== 'No Backup' && selectedBackupValue !== 'Backup') {
          console.info('Validando reservaciones del vestido principal y backup')

          const backupInventory = Number( inputBackupInventories.find((input) => input.value === selectedBackupValue)?.getAttribute('data-inventory') )

          // LOG
          // console.log({ backupInventory, mainInventory })
          if( mainInventory > 1 && backupInventory > 1 ) return

          const localeDate = date.toLocaleDateString('es-MX')

          const blockedDays = window.proficient.data.blockedDays || []

          if( blockedDays.includes( localeDate ) ) {
            console.log('disabled')
            return {
              disabled: true,
              attrs: {
                title: 'Dia no disponible'
              }
            }
          }

        } else {
          // we only validate main select
          console.info('Validando solo reservaciones del vestido principal')

          // LOG
          // console.log({ mainInventory })
          if( mainInventory > 1 ) return

          const localeDate = date.toLocaleDateString('es-MX')
          const blockedDays = window.proficient.data.blockedDays || []

          if( blockedDays.includes( localeDate ) ) {
            console.log('disabled')
            return {
              disabled: true,
              attrs: {
                title: 'Dia no disponible'
              }
            }
          }

        }
      },
      onSelect: onSelectDate,
    })
  }
}

function onSelectDate(fd, date, inst) {
  if( fd === '' ) return

  inst.update({ onSelect: '' });

  inst.selectedDates = []

  inst.selectDate([date[0], new Date(date[0].getTime() + (84600000 * planRentSelectedDays)) ])
  pickedDate = false

  inst.update({
    onSelect: onSelectDate
  });
}


/**
 * this generates the block days depending of the variants selected 
 * @returns { void }
 */
const generateBlockedDays = () => {
  // console.info('generando dias blockeados')
  const mainBookedDays = getReservations('main')
  const backupBookedDays = getReservations('backup')

  const reservations = [ ...mainBookedDays, ...backupBookedDays ]
  console.log({ reservations })

  let blockedTimes = []
  for( const reservation of reservations ) {
    const startDate = new Date(reservation.startDate)
    const duration = reservation.duration
    const time = startDate.getTime()

    // block the 8 previous days
    for( let i = 1; i <= 8; i++) {
      const date = sumDays(startDate, -1 * i)
      const time = date.getTime()
      blockedTimes.push(time)
    }

    let endDate = null
    blockedTimes.push(time)
    for( let i = 1; i <= Number(duration); i++ ) {
      const date = sumDays(startDate, i)
      const time = date.getTime()
      blockedTimes.push(time)
      if( i === duration) {
        endDate = date
      }
    }

    // we block the 7 next days from end date
    for( let i = 1; i <= 7; i++) {
      const date = sumDays(endDate, i)
      const time = date.getTime()
      blockedTimes.push(time)
    }
  }

  let blockedDays = Array.from( new Set( blockedTimes ) )
  blockedDays = blockedDays.sort((a,b) => a - b).map( time => new Date(time).toLocaleDateString('es-MX'))
  
  window.proficient.data = {
    ...window.proficient.data,
    blockedDays
  }

  console.info({ blockedDays })
}

/**
 * bundle all booked days in a reservation object
 * @param { 'backup' | 'main' } type 
 * @returns { any[] }
 */
function getReservations(type){
  /**
  * @type { { mainBookedDays: [], backupBookedDays: [] } }
  */
  const data = window.proficient.data

  const bookedDates = type == 'main' ? (data.mainBookedDays || []) : (data.backupBookedDays || [])

  const reservations = []

  bookedDates.forEach( bookedDay => {
    if( reservations.length === 0 ) {
      reservations.push({id: bookedDay._id, startDate: new Date(bookedDay.date), duration: 1, available: bookedDay.available })
      return
    }

    const reservation = reservations.find( (reservation) => bookedDay._id === reservation.id )

    if( !reservation ) {
      reservations.push({ id: bookedDay._id, startDate: new Date(bookedDay.date), duration: 1, available: bookedDay.available })
      return
    }

    reservation.duration += 1
  })

  return reservations
}

/**
 * @param { Date } date
 * @param { number } days 
 */
const sumDays = (date, days = 1) => {
  if( !date instanceof Date ) throw new Error('date param must to be type Date')

  const oneDay = 86400000
  const time = date.getTime()

  return new Date(time + (oneDay * days))
}

window.proficient.utils = {
  ...window.proficient.utils,
  generateBlockedDays
}